import React from 'react';
import { Home, Building2, Sparkles } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: <Home size={48} />,
      title: 'Residential Windows',
      description: 'Complete exterior and interior window cleaning for single-family and multi-story homes. We handle standard windows with care and precision.'
    },
    {
      icon: <Building2 size={48} />,
      title: 'Hard-to-Reach Windows',
      description: 'Second-story, tall windows, and difficult-access areas are our specialty. Safe, professional service for those challenging spots.'
    },
    {
      icon: <Sparkles size={48} />,
      title: 'Sill & Frame Detail Cleaning',
      description: 'Beyond the glass — we clean window sills, frames, and tracks to remove built-up dirt, dust, and debris for a complete finish.'
    }
  ];

  return (
    <section id="services" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-['Bebas_Neue'] text-6xl md:text-7xl text-white mb-4">
            OUR SERVICES
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Professional window cleaning services tailored for West Texas homes
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-zinc-900 to-black border border-zinc-800 rounded-lg p-8 hover:border-[#CC0000] transition-all duration-300 relative overflow-hidden"
            >
              {/* Red underline animation on hover */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#CC0000] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
              
              <div className="text-[#CC0000] mb-6 group-hover:scale-110 transition-transform duration-300">
                {service.icon}
              </div>
              
              <h3 className="font-['Bebas_Neue'] text-3xl text-white mb-4 tracking-wide">
                {service.title}
              </h3>
              
              <p className="text-gray-400 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
